export default {
  gaAction: 'Theme Park',
  smallHeadingText: 'TAKE YOUR VACATION TO THE NEXT LEVEL',
  headingText: 'Universal Orlando Resort™ Vacations',
  contentText:
    'Find exclusive offers and deals on Universal Orlando™ tickets and hotels providing on-site guests more ride time, more free time and more family time every day of their vacation!',
  image:
    'https://s1.pclncdn.com/pcln/promotions/disney-universal-2020/new-harrypotter.jpg',
  imageWebP:
    'https://s1.pclncdn.com/pcln/promotions/disney-universal-2020/new-harrypotter.webp',
  imageSize: '524px 322px',
  buttons: [
    {
      gaLabel: 'Universal Orlando',
      buttonText: 'More Info',
      linkUrl: '/partner/hotels/universal-orlando.html'
    }
  ]
}
